import "./App.css";
import { ReduxStoreProvider } from "./components/ReduxStoreProvider";
import MainRouter from "./pages/router/RouterMain";
import MainThemeProvider from "./theme/ThemeProvider";
import { ProjectProvider } from "@/features/projects/pages/AccountPage/components/context/ProjectContext";
import "@ant-design/v5-patch-for-react-19";
import BootstrapSystem from "./pages/Bootstrap";
import LocaleProvider from "./locales/LocaleProvider";

function AppContent() {
  return <MainRouter />;
}

function App() {
  return (
    <ReduxStoreProvider>
      <LocaleProvider>
        <MainThemeProvider>
          <ProjectProvider>
            <BootstrapSystem>
              <AppContent />
            </BootstrapSystem>
          </ProjectProvider>
        </MainThemeProvider>
      </LocaleProvider>
    </ReduxStoreProvider>
  );
}

export default App;
